<template>
  <div>
    <span class="inlineblock width100 yellowfont minfont">
                  <span>{{ fieldName }}：</span>
                  <span>
                    <a
                      style="color:#ff0000"
                      @click="viewImg(attachmentUrl)">查看</a>
                  </span>
                </span>
    <preview-modal ref="imageModal"></preview-modal>
  </div>
</template>

<script>
  import PreviewModal from '@views/general/modules/PreviewModal.vue'

  export default {
    name: 'PAttachment',
    components: { PreviewModal },
    props: {
      fieldName: {
        type: String,
        default: ''
      },
      attachmentUrl: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        imgUrl: ''
      }
    },
    mounted() {
      this.addWarker(this.attachmentUrl, '仅供本网站展示，不得转载\n      https://gbacpc.org.cn')
    },
    methods: {
      initData() {
      },
      addWarker(url, warkerName) {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const image = new Image()
        image.src = url
        image.setAttribute('crossOrigin', 'Anonymous')
        image.onload = () => {
          canvas.width = image.width
          canvas.height = image.height
          ctx.drawImage(image, 0, 0)

          // 绘制水印 旋转45度
          ctx.font = '50px Arial'
          ctx.rotate(270)
          ctx.fillStyle = 'rgba(187,187,187,0.5)' // 白色半透明
          const lines = warkerName.split('\n')
          for (let i = 0; i < 4; i++) {
            for (let j = 0; j < 2; j++) {
              lines.forEach((item, index) => {
                ctx.fillText(item, ((canvas.width / 2) + 30) * j, (canvas.height / 4) * i + 50 * index)
              })
            }
          }
          // 将canvas转换为图片源
          console.log(canvas.toDataURL('image/png'))
          this.imgUrl = canvas.toDataURL('image/png')
        }
      },
      viewImg(url) {
        // 预览静态图片
        this.$refs.imageModal.show(this.imgUrl)
      }
    }
  }
</script>

<style lang="less" scoped>
.yellowfont {
  color: #faefac;
}

.inlineblock {
  display: inline-block;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.widthStyle {
  word-wrap: break-word;
}

.minfont {
  font-size: 1rem !important;
}
</style>
